import React, { Component } from "react";
import { connect } from "react-redux";
import {
  UploadCSVFileAction,
  TriggerFileUploadAction,
  SendCSVForAnalysisAction,
  AddAnalysisFileNamesToRedux,
  ResetAnalysisMessageAction,
  RenderOnSite,
  AddAnalysisFileIDToRedux,
} from "../../../Actions/Analysis";
import UploadSVG from "../../../Assets/svg/UploadSVG.svg";
import { withRouterHooks } from "../../../withRouters/withRoutersHook";
import PropTypes from "prop-types";

class UploadCSVFile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      file: null,
      error: null,
    };
    this.fileInputRef = React.createRef();
  }

  static propTypes = {
    UploadCSVFileAction: PropTypes.func.isRequired,
    TriggerFileUploadAction: PropTypes.func.isRequired,
    csvFileUploadSuccess: PropTypes.bool,
    csvFileUploadFail: PropTypes.bool,
    SendCSVForAnalysisAction: PropTypes.func.isRequired,
    AddAnalysisFileNamesToRedux: PropTypes.func.isRequired,
    ResetAnalysisMessageAction: PropTypes.func.isRequired,
    RenderOnSite: PropTypes.func.isRequired,
    AddAnalysisFileNamesToRedux: PropTypes.func.isRequired,
  };

  handlePath = () => {
    const { pathname } = this.props.location;
    return pathname === "/dashboard"
      ? "CSV"
      : pathname === "/dashboard/pdf-analyzer"
      ? "PDF"
      : "";
  };

  handleAnalysisFlow = () => {
    const { pathname } = this.props.location;
    if (pathname === "/dashboard") return "survey";
    if (pathname === "/dashboard/pdf-analyzer") return "smart_extract";
    return "";
  };

  validateFile = (file) => {
    const fileType = this.handlePath();
    if (fileType === "CSV" && !file.name.toLowerCase().endsWith(".csv")) {
      this.setState({ error: "Only CSV files are accepted. Please upload a .csv file.", file: null });
      return false;
    }
    if (file.size > 3 * 1024 * 1024) {
      this.setState({ error: "File size exceeds the 3MB limit.", file: null });
      return false;
    }
    return true;
  };

  handleFileChange = (event) => {
    const file = event.target.files[0];
    if (!file) return;
    if (this.validateFile(file)) {
      this.setState({ file, error: null });
      this.uploadFile(file);
    }
    event.target.value = "";
  };

  handleDrop = (event) => {
    event.preventDefault();
    const file = event.dataTransfer.files[0];
    if (!file) return;
    if (this.validateFile(file)) {
      this.setState({ file, error: null });
      this.uploadFile(file);
    }
  };

  uploadFile = (file) => {
    const fileType = this.handlePath();
    const analysisFlow = this.handleAnalysisFlow();
    if (!fileType) return;

    this.props.TriggerFileUploadAction();
    this.props.ResetAnalysisMessageAction();

    const uploadAction = () => {
      this.props.UploadCSVFileAction(file, fileType.toLowerCase(), analysisFlow).then((res) => {
        const { id, file_name } = res.data || res;
        this.props.SendCSVForAnalysisAction(id);
        this.props.AddAnalysisFileIDToRedux(id);
        this.props.AddAnalysisFileNamesToRedux(file_name);

        // if (fileType === "PDF") {
        //   this.props.RenderOnSite();
        // }
      });
    };

    setTimeout(uploadAction, 3000);
  };

  handleChooseFileClick = () => {
    this.fileInputRef.current.click();
  };

  render() {
    const { file, error } = this.state;

    return (
      <div
        className="flex flex-col w-full items-center justify-center font-inter gap-5 rounded-2xl p-10 border-2 border-dashed border-blue-200 transition-all duration-200 cursor-pointer"
        style={{ background: "linear-gradient(135deg, #ffffff 0%, #eff6ff 60%, #eef2ff 100%)" }}
        onDragOver={(e) => e.preventDefault()}
        onDrop={this.handleDrop}
      >
        <img
          src={UploadSVG}
          alt="UploadSVG"
          className="w-16 h-16"
        />
        <div className="flex flex-col gap-3 items-center text-center">
          <p className="text-gray-700 font-medium text-sm">
            Drag & drop your file here
          </p>
          <button
            type="button"
            className="flex items-center gap-2 px-4 py-2 rounded-lg bg-gradient-to-r from-primary-blue to-blue-400 text-white text-sm font-medium hover:from-blue-600 hover:to-blue-500 transition-all duration-150 shadow-sm"
            onClick={this.handleChooseFileClick}
          >
            Choose File
          </button>
          <input
            type="file"
            accept={
              this.handlePath() === "CSV"
                ? ".csv"
                : this.handlePath() === "PDF"
                ? ".pdf"
                : ""
            }
            ref={this.fileInputRef}
            onChange={this.handleFileChange}
            style={{ display: "none" }}
          />
          <p className="text-xs text-gray-400">
            Accepted: <span className="font-medium text-gray-500">{this.handlePath() === "CSV" ? "CSV only" : this.handlePath() === "PDF" ? "PDF only" : ""}</span>
            {" · "}Maximum Size: <span className="text-red-400 font-medium">3MB</span>
          </p>
          {file && (
            <div className="mt-1 text-xs text-green-600 bg-green-50 border border-green-100 rounded-lg px-3 py-1.5">
              ✓ Selected: {file.name}
            </div>
          )}
          {error && (
            <div className="mt-1 text-xs text-red-500 bg-red-50 border border-red-100 rounded-lg px-3 py-1.5">
              {error}
            </div>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  csvFileUploadSuccess: state.analysis?.csvFileUploadSuccess,
});

export default withRouterHooks(
  connect(mapStateToProps, {
    UploadCSVFileAction,
    TriggerFileUploadAction,
    SendCSVForAnalysisAction,
    AddAnalysisFileNamesToRedux,
    ResetAnalysisMessageAction,
    RenderOnSite,
    AddAnalysisFileIDToRedux,
  })(UploadCSVFile)
);
